import { models } from "powerbi-client"; // importing from powerbi-client, also sets a built powerbi client to window object...
import geHTTP from "data-model";

const powerbi = ("powerbi" in window && window["powerbi"]) || {};
const tokenURL = `Report/ADToken/BI`;

const apiURL = `https://api.powerbi.com/v1.0/myorg/groups/`;

function validate({
  $containerEl = undefined,
  embedUrl = undefined,
  embedToken = undefined,
} = {}) {
  if (!$containerEl) {
    throw new Error(`$containerEl is not defined.`);
  }

  if (!embedUrl) {
    throw new Error(`Embed URL is required.`);
  }

  if (!embedToken) {
    throw new Error(`Embed Token is missing or you do not have permission.`);
  }
}

function PowerBiService() {
  // NOTE: Need to get a new accesstoken for each new report request...
  // The report's embed token expiration is generated based off of the sent accesstoken expiration when making the request.
  const getAccessToken = async () => {
    return new Promise((resolve, reject) => {
      geHTTP
        .ajaxRequest(tokenURL, "GET", null, true)
        .done((token) => {
          resolve(token.accessToken);
        })
        .fail((err) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`,
          ),
        );
    });
  };

  const getReportsAsync = async (workspaceId) => {
    const accessToken = await getAccessToken();

    const options = {
      method: "get",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    const { value } = await fetch(`${apiURL}/${workspaceId}/reports`, options)
      .then((res) => res.json())
      .catch(() => ({ value: [] }));
    return (value || []).map(({ id, name, embedUrl, datasetId, webUrl }) => ({
      id,
      name,
      embedUrl,
      datasetId,
      webUrl,
    }));
  };

  const getReportEmbedToken = async ({
    workspaceId = "",
    reportId = "",
    datasetIds = [],
    username = "EffectiveIdentity",
    roles = [],
  } = {}) => {
    const accessToken = await getAccessToken();
    console.log(reportId, datasetIds, username, roles);
    const options = {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accessLevel: "View",
        allowSaveAs: "false",
        identities:
          [
            "2cb1b188-1787-4e76-9ca0-67af6a125ffd",
            "3a48b5d2-c4cf-4bd8-8e06-b9973261191c",
          ].indexOf(reportId) > -1
            ? []
            : [
                {
                  username: username,
                  roles: [...roles],
                  datasets: [...datasetIds],
                  reports: [reportId],
                },
              ],
      }),
    };

    const url = `${apiURL}/${workspaceId}/reports/${reportId}/GenerateToken`;

    const { token } = await fetch(url, options)
      .then((res) => res.json())
      .catch(() => ({}));

    return token || "";
  };

  const embedTo = async (
    $containerEl,
    {
      embedUrl = "",
      reportId = "",
      workspaceId = "",
      datasetIds = [],
      username = "EffectiveIdentity",
      roles = [],
      settings = {
        filterPaneEnabled: true,
        navContentPaneEnabled: true,
        layoutType: models.LayoutType.Custom,
        customLayout: {
          displayOption: models.DisplayOption.FitToWidth,
          //reportAlignment: models.ReportAlignment.Center,
        },
      },
    } = {},
  ) => {
    const embedToken = await getReportEmbedToken({
      workspaceId,
      reportId,
      datasetIds,
      username,
      roles,
    }); // lasts a few hours

    validate({ $containerEl, embedToken, embedUrl });

    const report = powerbi.embed($containerEl, {
      type: "report",
      tokenType: models.TokenType.Embed,
      accessToken: embedToken, // Report access token, not the api token
      embedUrl,
      id: reportId,
      permissions: models.Permissions.All,
      settings: settings || {},
    });

    // report.on("loaded", () => console.log("Report loaded"));
    // report.on("rendered", () => console.log("Report rendered"));
    report.on("error", (e) => console.error("PBI error event:", e.detail || e));

    return report;
  };

  return {
    getReportsAsync,
    embedTo,
  };
}

const instance = PowerBiService();
export default instance;
